import { SNACKBAR_EVENTS } from '../custom-events/snackbar';
import { CLASS_NAMES, DISPLAY_DURATION, SELECTORS } from './constants';

export class GlobalSnackbar {
  container = document.querySelector(`.${SELECTORS.CONTAINER}`);
  message = this.container.querySelector(`.${SELECTORS.MESSAGE}`);
  status = document.querySelector(`.${SELECTORS.STATUS}`);
  closeButton = this.container.querySelector(`.${SELECTORS.CLOSE}`);
  hideTimerId = null;
  timerStartedAt = null;
  remainingDuration = DISPLAY_DURATION;

  renderSegments = (segments) => {
    const elements = segments.map(({ text, emphasized }) => {
      const segment = document.createElement('span');

      segment.classList.add(CLASS_NAMES.SEGMENT);
      segment.textContent = text;

      if (emphasized) {
        segment.classList.add(CLASS_NAMES.SEGMENT_EMPHASIZED);
      }

      return segment;
    });

    this.message.replaceChildren(...elements);
    this.status.textContent = segments.map(({ text }) => text).join('');
  };

  clearHideTimer = () => {
    if (this.hideTimerId !== null) {
      window.clearTimeout(this.hideTimerId);
      this.hideTimerId = null;
    }
  };

  isInteractionActive = () => this.container.matches(':hover') || this.container.contains(document.activeElement);

  startHideTimer = () => {
    if (this.isInteractionActive()) {
      return;
    }

    this.timerStartedAt = Date.now();
    this.hideTimerId = window.setTimeout(this.hide, this.remainingDuration);
  };

  pauseHideTimer = () => {
    if (this.hideTimerId === null) {
      return;
    }

    const elapsed = Date.now() - this.timerStartedAt;

    this.remainingDuration = Math.max(0, this.remainingDuration - elapsed);
    this.clearHideTimer();
  };

  resumeHideTimer = () => {
    const isVisible = this.container.classList.contains(CLASS_NAMES.VISIBLE);

    if (!isVisible || this.hideTimerId !== null || this.isInteractionActive()) {
      return;
    }

    this.startHideTimer();
  };

  show = ({ detail: { segments }}) => {
    this.clearHideTimer();
    this.renderSegments(segments);
    this.remainingDuration = DISPLAY_DURATION;
    this.container.classList.add(CLASS_NAMES.VISIBLE);
    this.startHideTimer();
  };

  hide = () => {
    this.clearHideTimer();
    this.container.classList.remove(CLASS_NAMES.VISIBLE);
    this.remainingDuration = DISPLAY_DURATION;
    this.timerStartedAt = null;
  };

  handleFocusOut = ({ relatedTarget }) => {
    if (!this.container.contains(relatedTarget)) {
      this.resumeHideTimer();
    }
  };

  initialize = () => {
    document.addEventListener(SNACKBAR_EVENTS.SHOW, this.show);
    this.closeButton.addEventListener('click', this.hide);
    this.container.addEventListener('mouseenter', this.pauseHideTimer);
    this.container.addEventListener('mouseleave', this.resumeHideTimer);
    this.container.addEventListener('focusin', this.pauseHideTimer);
    this.container.addEventListener('focusout', this.handleFocusOut);
  };
}
